import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=92775aa8&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=92775aa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92775aa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/matt/dev/georgia/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92775aa8')) {
      api.createRecord('92775aa8', component.options)
    } else {
      api.reload('92775aa8', component.options)
    }
    module.hot.accept("./MainView.vue?vue&type=template&id=92775aa8&scoped=true&", function () {
      api.rerender('92775aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "MainView.vue"
export default component.exports